import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualSellerPage } from './manual-seller.page';

const routes: Routes = [
  {
    path: '',
    component: ManualSellerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualSellerPageRoutingModule {}
